import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button, Popover } from 'antd';
import { TPA_DB_TAG_LIST_CLAIM_VIEW, TPA_DB_TAG_LIST_NAME, TPA_DB_TAG_LIST_PRE_AUTH_VIEW, TPA_TIME_FILTER_CONST } from '../../constants/crmConstants';
import './tag.less';
import { searchInPatientList, setTPANextStatus, setTPASecondaryFilter, setTPATimeFilter} from '../../../store/actions/inPatientAction';
import { RootState } from '../../../store';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';
import { ReactComponent as ResetFilterIcon } from '../../../../src/assets/images/svg/ResetFilterIcon.svg';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';

const TagList = (props: any): ReactElement => {
  const {
    data = {}, handleDraft, resetFilter,
  } = props;
  const { tpaNextStatus, timeFilter, isPreAuthView } =
    useSelector((state: RootState): any => state.selectedInPatientDetail || {});
    const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const dispatch = useDispatch();
  const isPreAuthClaimViewEnabled = appDetail?.getIsPreAuthClaimViewEnabled();
  const selectedList = (isPreAuthClaimViewEnabled) ? (isPreAuthView ? TPA_DB_TAG_LIST_PRE_AUTH_VIEW :
     TPA_DB_TAG_LIST_CLAIM_VIEW)  : TPA_DB_TAG_LIST_NAME;
  const handleClick = (selectedStatus: any, selectedTimeFilter: string): any => {
    const eventMap: {[key: string]: string} = {
      'DRAFTCLAIM': selectedTimeFilter === 'Last3Hours'
      ? 'Drafts pending >3 hrs' : 'TPA desk dashboard - Drafts Pending',
      'PENDINGQUERY': selectedTimeFilter === 'Last3Hours'
      ? 'Queries pending >3 hrs' : 'TPA desk dashboard - Queries Pending',
      'AWAITINGDISCHARGE': selectedTimeFilter === 'Today'
      ? 'Awaiting Discharge Today' : selectedTimeFilter === 'Tomorrow'
      ? 'Awaiting Discharge Tomorrow' : 'TPA desk dashboard - Awaiting Discharge',
      'APPROVALPENDING': 'TPA desk dashboard - Approval Pending',
      'PREAUTHDRAFTS' : selectedTimeFilter === 'Last3Hours'
      ? 'PreAuth - Drafts pending >3 hrs' : 'PreAuth - Drafts Pending',
      'PREAUTHPENDINGQUERY': selectedTimeFilter === 'Last3Hours'
      ? 'PreAuth - Queries pending >3 hrs' : 'PreAuth - Queries Pending',
      'CLAIMVIEWDRAFTS': selectedTimeFilter === 'Last3Hours'
      ? 'Claim View - Drafts pending >3 hrs' : 'Claim View - Drafts Pending',
      'CLAIMPENDINGQUERY' : selectedTimeFilter === 'Last3Hours'
      ? 'Claim View - Queries pending >3 hrs' : 'Claim View - Queries Pending',
      'SETTLEDCLAIMS' : 'Claims View - Settled Claims',
      'AWAITINGSETTLEMENT': 'Claims View - Awaiting Settlement',
    };

    const eventName = eventMap[selectedStatus];
    customGTMEvent({
      event: eventName,
    });
    if (selectedStatus === tpaNextStatus && selectedTimeFilter === timeFilter) {
      return;
    } else {
      resetFilter();
      if (selectedStatus === 'DRAFTCLAIM' || selectedStatus === 'CLAIMVIEWDRAFTS' || selectedStatus === 'PREAUTHDRAFTS') {
        handleDraft('DRAFT');
      }
      dispatch(setTPATimeFilter(selectedTimeFilter));
      dispatch(setTPANextStatus(selectedStatus));
      dispatch(setTPASecondaryFilter(undefined));
      dispatch(searchInPatientList());
    }
  };
  return (
    <div className="ant-tabs-content-holder tab-custom-container">
      <Row
        className={
          'inpatient-tags-wrapper'
        }
        justify="space-between"
      >
        {
          selectedList?.map((list: any, index: number): any =>
            <Col
              key={index}
              className={
                `${
                  (list?.sectionType === 2 || list?.sectionType === 4)
                  ? 'inpatient-tags content-center rm-padding'
                  : 'inpatient-tags content-center'
                }${
                  list.id !== tpaNextStatus && tpaNextStatus !== undefined
                    ? ' disabled-tag' : ''
                }`
              }
              id="tpaDashboardClicks"
            >
              <div
                className={
                  list?.sectionType === 3
                    ? 'tags-content content-center'
                    : 'tags-content content-center mouse-pointer'
                }
              >
                <div
                  className={`${isPreAuthView ? 'tags-title' : 'tags-title-claim-view'} mouse-pointer`}
                  onClick={(event: any): any => handleClick(list?.id, TPA_TIME_FILTER_CONST.ALL)}
                >
                  {list?.name?.includes('/') ? (
               list?.name?.split('/')?.map((part: any, indexes: any): any => (
               <div key={indexes}>{part?.trim()}</div>
            ))
            ) : (
            list?.name
  )}
                </div>
                {list?.sectionType === 3
                  ?
                  <>
                    <div className="tags-day-wise mouse-pointer" id="tpaDashboardAwaitingDischarge"
                      onClick={(event: any): any => handleClick(list?.id, TPA_TIME_FILTER_CONST.TODAY)}
                    >
                      <div
                        className="tags-day-wise-count"
                      >
                        {data[list?.id]?.todayCount}
                      </div>
                      Today
                    </div>
                    <div className="tags-day-wise mouse-pointer" id="tpaDashboardAwaitingDischarge"
                      onClick={(event: any): any => handleClick(list?.id, TPA_TIME_FILTER_CONST.TOMORROW)}
                    >
                      <div className="tags-day-wise-count">{data[list?.id]?.tomorrowCount}</div>
                      Tomorrow
                    </div>
                  </>
                  :
                  <div className="tags-count-wrapper" id="tpaDashboardClicks"
                    onClick={(event: any): any => handleClick(list?.id, TPA_TIME_FILTER_CONST.ALL)}
                  >
                    <div className={isPreAuthView ? 'tags-count' : 'tags-count-claimView'}>{data[list.id]?.totalCount}</div>
                  </div>
                }
              </div>

              {(list?.sectionType === 2 || list?.sectionType === 4) &&
                <div className="tags-content content-center mouse-pointer" id="tpaDashboardClicks"
                  onClick={(event: any): any => handleClick(list?.id, TPA_TIME_FILTER_CONST.LAST3HRS)}
                >
                  <div className="tags-title three-hour-search">{`>3hrs`}</div>
                  <div className="tags-count-wrapper">
                    <div className="tags-count">{data[list?.id]?.last3HoursCount}</div>
                  </div>
                </div>}
            </Col>,
          )
        }
        <Col>
          <Popover content={
                  <span
                 className="inpatient_tooltip_header"
                  >
                    Reset Filter
                  </span>
                } mouseEnterDelay={0.25}>
            <Button
              className="reset-button"
              data-testid="clear-filter"
              onClick={(event: any): any => resetFilter(event, true)}
              type="link"
            >
              {
                isPreAuthClaimViewEnabled ? <ResetFilterIcon/> : 'Reset Filters' }
            </Button>
          </Popover>
        </Col>
      </Row>
    </div>
  );
};

export default TagList;
